export default __webpack_public_path__ + "static/media/3_Intro.696a90d0.mp4";